import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import axios from "axios";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, logout, apiBaseUrl } = useAuth();

  console.log(process.env.REACT_APP_Sabzi_BASE);

  // const apiBaseUrl = apiBaseUrl

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError('');
  //   setLoading(true);

  //   try {
  //     const response = await axios.post(apiBaseUrl + '/api/auth/login', {
  //       username: username,
  //       password: password
  //     });

  //     console.log('Login Response:', response.data);

  //     if (response.data.success) {
  //       localStorage.setItem('token', response.data.data.token);
  //       console.log('User Data:', response.data.data.user);
  //       login(response.data.data.user);
  //     }

  //   } catch (error) {
  //     console.error('Login Error:', error);
  //     setError('خطا در ورود به سیستم');
  //     if (error.response) {
  //       console.log('Error Response:', error.response.data);
  //       setError(error.response.data.message || 'نام کاربری یا رمز عبور اشتباه است');
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // مرحله 1: لاگین و دریافت token
      const response = await axios.post(apiBaseUrl + "/api/auth/login", {
        username: username,
        password: password,
      });

      if (response.data.success) {
        const token = response.data.data.token;

        // ذخیره token در localStorage
        localStorage.setItem("token", token);

        // مرحله 2: دریافت اطلاعات کامل کاربر با استفاده از token
        const userRes = await axios.get(apiBaseUrl + "/api/auth/me", {
          headers: {
            Authorization: "Bearer " + token,
          },
        });

        // set کردن user در context یا state
        login(userRes.data.data.user);
      }
    } catch (error) {
      console.error("Login Error:", error);
      setError("خطا در ورود به سیستم");

      if (error.response) {
        setError(
          error.response.data.message || "نام کاربری یا رمز عبور اشتباه است"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
      style={{
        direction: "rtl",
        backgroundColor: "#1f2937",
      }}
    >
      {/* Background animated circles with blur */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute rounded-full opacity-20 blur-3xl animate-pulse"
          style={{
            width: "600px",
            height: "600px",
            background: "radial-gradient(circle, #fd0d0e 0%, transparent 70%)",
            top: "-200px",
            right: "-200px",
            animationDuration: "4s",
          }}
        ></div>
        <div
          className="absolute rounded-full opacity-10 blur-3xl animate-pulse"
          style={{
            width: "500px",
            height: "500px",
            background: "radial-gradient(circle, #fd0d0e 0%, transparent 70%)",
            bottom: "-150px",
            left: "-150px",
            animationDuration: "6s",
            animationDelay: "1s",
          }}
        ></div>
        <div
          className="absolute rounded-full opacity-15 blur-2xl animate-pulse"
          style={{
            width: "400px",
            height: "400px",
            background: "radial-gradient(circle, #fd0d0e 0%, transparent 70%)",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            animationDuration: "5s",
            animationDelay: "0.5s",
          }}
        ></div>
      </div>

      <div className="w-full max-w-md relative z-10">
        {/* Logo/Brand Section with animation */}
        <div
          className="text-center mb-8"
          style={{ animation: "fadeInDown 0.6s ease-out" }}
        >
          <div
            className="inline-flex items-center justify-center w-28 h-28 rounded-full mb-4 transform transition-transform hover:scale-110"
            style={{
              backgroundColor: "rgba(253, 13, 14, 0.1)",
              boxShadow:
                "0 0 50px rgba(253, 13, 14, 0.3), 0 0 100px rgba(253, 13, 14, 0.1)",
              backdropFilter: "blur(10px)",
            }}
          >
            <img
              src="/logo/ahangari-holding.svg"
              alt="Logo"
              className="w-20 h-20"
              style={{ filter: "drop-shadow(0 0 10px rgba(253, 13, 14, 0.5))" }}
            />
          </div>

          <p className="text-gray-300 mt-3 text-lg font-medium">
            به پنل خود خوش آمدید
          </p>
        </div>

        {/* Login Card with glassmorphism */}
        <div
          className="rounded-3xl shadow-2xl p-8 border backdrop-blur-xl relative overflow-hidden"
          style={{
            backgroundColor: "rgba(17, 24, 39, 0.6)",
            borderColor: "rgba(55, 65, 81, 0.4)",
            boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
            animation: "fadeInUp 0.7s ease-out",
          }}
        >
          {/* Gradient overlay */}
          <div
            className="absolute inset-0 opacity-5"
            style={{
              background:
                "linear-gradient(135deg, #fd0d0e 0%, transparent 100%)",
              pointerEvents: "none",
            }}
          ></div>

          <div className="text-center mb-8 relative z-10">
            <h2 className="text-2xl font-bold text-white mb-3">
              ورود به سیستم
            </h2>
            <div
              className="w-16 h-1 mx-auto rounded-full"
              style={{
                backgroundColor: "#fd0d0e",
                boxShadow: "0 0 20px rgba(253, 13, 14, 0.6)",
              }}
            ></div>
          </div>

          {error && (
            <div
              className="mb-6 p-4 rounded-xl border text-sm text-center backdrop-blur-sm"
              style={{
                backgroundColor: "rgba(254, 226, 226, 0.9)",
                borderColor: "#fecaca",
                color: "#dc2626",
                animation: "shake 0.5s ease-in-out",
              }}
            >
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6 relative z-10">
            <div className="transform transition-all hover:translate-x-1">
              <label className="block text-sm font-medium text-gray-300 mb-2">
                نام کاربری
              </label>
              <div className="relative">
                <span className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg">
                  👤
                </span>
                <input
                  type="text"
                  placeholder="نام کاربری خود را وارد کنید"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full px-4 py-3 pr-12 rounded-xl border-2 text-white placeholder-gray-500 transition-all duration-300 focus:outline-none backdrop-blur-sm"
                  style={{
                    backgroundColor: "rgba(31, 41, 55, 0.5)",
                    borderColor: "#374151",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#fd0d0e";
                    e.target.style.backgroundColor = "rgba(31, 41, 55, 0.7)";
                    e.target.style.boxShadow =
                      "0 0 20px rgba(253, 13, 14, 0.2)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#374151";
                    e.target.style.backgroundColor = "rgba(31, 41, 55, 0.5)";
                    e.target.style.boxShadow = "none";
                  }}
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <div className="transform transition-all hover:translate-x-1">
              <label className="block text-sm font-medium text-gray-300 mb-2">
                رمز عبور
              </label>
              <div className="relative">
                <span className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg">
                  🔒
                </span>
                <input
                  type="password"
                  placeholder="رمز عبور خود را وارد کنید"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-3 pr-12 rounded-xl border-2 text-white placeholder-gray-500 transition-all duration-300 focus:outline-none backdrop-blur-sm"
                  style={{
                    backgroundColor: "rgba(31, 41, 55, 0.5)",
                    borderColor: "#374151",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#fd0d0e";
                    e.target.style.backgroundColor = "rgba(31, 41, 55, 0.7)";
                    e.target.style.boxShadow =
                      "0 0 20px rgba(253, 13, 14, 0.2)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#374151";
                    e.target.style.backgroundColor = "rgba(31, 41, 55, 0.5)";
                    e.target.style.boxShadow = "none";
                  }}
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-4 px-4 rounded-xl font-bold transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none relative overflow-hidden"
              style={{
                backgroundColor: loading ? "#6b7280" : "#fd0d0e",
                color: "white",
                cursor: loading ? "not-allowed" : "pointer",
                boxShadow: loading
                  ? "none"
                  : "0 8px 30px rgba(253, 13, 14, 0.4)",
                fontSize: "16px",
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.target.style.backgroundColor = "#dc2626";
                  e.target.style.boxShadow =
                    "0 12px 40px rgba(253, 13, 14, 0.5)";
                }
              }}
              onMouseLeave={(e) => {
                if (!loading) {
                  e.target.style.backgroundColor = "#fd0d0e";
                  e.target.style.boxShadow =
                    "0 8px 30px rgba(253, 13, 14, 0.4)";
                }
              }}
            >
              {/* Button shine effect */}
              <span
                className="absolute inset-0 opacity-0 hover:opacity-20 transition-opacity duration-300"
                style={{
                  background:
                    "linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)",
                }}
              ></span>

              {loading ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent ml-2"></div>
                  در حال ورود...
                </div>
              ) : (
                "ورود به سیستم"
              )}
            </button>
          </form>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-gray-700/50 text-center relative z-10">
            <p className="text-gray-400 text-sm">تمامی حقوق محفوظ است © 2025</p>
          </div>
        </div>

        {/* Bottom decoration */}
        <div className="text-center mt-6">
          <p className="text-gray-500 text-sm">نسخه 1.0.0</p>
        </div>
      </div>

      <style>{`
        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-8px); }
          50% { transform: translateX(8px); }
          75% { transform: translateX(-8px); }
        }
      `}</style>
    </div>
  );
}

export default Login;
